import _ from 'lodash';
import { structIterate } from './formula';
import type { FormulaNode, RawFormulaData } from '../typeDefs';

const assert = (bool: unknown, msg: string): void => {
    if (bool) return;
    console.error(msg);
    throw msg;
};

const validateFormula = (formula: RawFormulaData): void => {
    assert(formula, 'Invalid root formula');

    const { structure, checker, functions } = formula;

    assert(_.isPlainObject(structure), 'Invalid root structure');
    validateStruct(structure, ['structure']);

    assert(!checker || _.isPlainObject(checker), 'Invalid checker structure');
    if (checker) validateStruct(checker, ['checker']);

    assert(!functions || Array.isArray(functions), 'Invalid functions array');
    if (functions) functions.forEach((func, index) => validateFunction(func, ['functions', index]));
};

export default validateFormula;

const validateStruct = (
    struct: FormulaNode,
    path: Array<string | number>,
    subPath: string = 'root',
): void => {
    const err = (msg: string) =>
        `[${path.join('.')}:${subPath} | ${_.get(struct, '$op', '<no-$op>')}] ${msg}`;

    assert(_.isPlainObject(struct), err('Invalid sub-structure'));
    assert(struct.$op, err('Missing $op'));
    assert(struct.$value, err('Missing $value'));

    if (subPath !== 'root') return;

    structIterate(struct, (subStruct, childPath) => {
        validateStruct(subStruct, path, childPath);
    });
};

const validateFunction = (
    obj: { id: string; name?: string; structure: FormulaNode },
    path: Array<string | number>,
): void => {
    const flair = `${path.join('.')} | ${_.get(obj, 'id')} | ${_.get(obj, 'name')}`;
    const err = (msg: string) => `[${flair}] ${msg}`;

    assert(_.isPlainObject(obj), err('Invalid function'));
    assert(obj.id, err('Invalid function id'));
    assert(obj.name, err('Invalid function name'));
    assert(obj.structure, err('Invalid function structure'));

    validateStruct(obj.structure, [flair]);
};
